import { PlaceholderRangeEditorProps } from "../../../../types/bulkEmails/CriteriaOption";
import { Row } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FloatNumberInput } from "../../../../components/FloatNumberInput";
import { Rule } from "antd/es/form";
import { transformToFloat } from "../../../../lib/transformToFloat";

export const DefaultCurrencyRangeCriteria = ({
  value,
  onChange,
  form,
  formKeys,
  placeholders
}: PlaceholderRangeEditorProps) => {
  const [initialized, setInitialized] = useState(false);

  const [startKey, endKey] = formKeys;

  const normalizedValue = useMemo<[string | null | undefined, string | null | undefined]>(() => {
    if (Array.isArray(value)) {
      return [value[0] ?? null, value[1] ?? null];
    }

    return [null, null];
  }, [value]);

  const startRules = useMemo(() => [{ required: true, message: "Please enter From value" }], []);

  const endRules = useMemo(
    () => [
      {
        validator(_r: Rule, value: undefined | null | string) {
          if (value === null || value === undefined || value === "") {
            return Promise.resolve();
          }

          const startValue = normalizedValue[0];

          if (!startValue) {
            return Promise.reject(new Error("From value must be set before To value"));
          }

          if (startValue && transformToFloat(value)! < transformToFloat(startValue)!) {
            return Promise.reject(new Error("To value must be greater than From value"));
          }

          return Promise.resolve();
        }
      }
    ],
    [normalizedValue]
  );

  useEffect(() => {
    if (!initialized) {
      form.setFieldValue(startKey, normalizedValue[0]);
      form.setFieldValue(endKey, normalizedValue[1]);
      onChange(normalizedValue);
      setInitialized(true);
    }
  }, [endKey, form, initialized, normalizedValue, onChange, startKey]);

  const handleStartChange = useCallback(
    (nextValue: any) => {
      onChange([nextValue || null, form.getFieldValue(endKey) || null]);
    },
    [endKey, form, onChange]
  );

  const handleEndChange = useCallback(
    (nextValue: any) => {
      onChange([form.getFieldValue(startKey) || null, nextValue || null]);
    },
    [form, onChange, startKey]
  );

  return (
    <Row className="criteria-range align-start w-100">
      <Row className="align-start justify-space-between">
        <span className="text-md title label">{placeholders?.[0]}</span>
        <FloatNumberInput
          name={startKey}
          label=""
          form={form}
          className="criteria-range-item input mb-0"
          rules={startRules}
          onChange={(value) => handleStartChange(value)}
          includeThousandsSeparator
        />
      </Row>
      <Row className="align-start justify-space-between">
        <span className="text-md title label">{placeholders?.[1]}</span>
        <FloatNumberInput
          name={endKey}
          label=""
          form={form}
          className="criteria-range-item input mb-0"
          rules={endRules}
          onChange={(value) => handleEndChange(value)}
          includeThousandsSeparator
        />
      </Row>
    </Row>
  );
};
